import Typography from '@mui/material/Typography'

interface CreditBalanceProps {
  creditBalance: number
}

const formatAUD = (amount: number): string =>
  new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(
    amount
  )

const CreditBalance = ({ creditBalance }: CreditBalanceProps) => {
  if (creditBalance === 0) {
    return (
      <Typography variant='body1' color='text.secondary'>
        No credits
      </Typography>
    )
  }

  return <Typography variant='body1'>{formatAUD(creditBalance)}</Typography>
}

export default CreditBalance
